<template>
  <div>
    <h5 class="mb-4">Banner</h5>
    <b-row>
      <b-col xl="6">
        <div>
          <b-form-group>
            <cool-label>
              Blocked Attributes
              <span v-b-popover.hover.click.right="'Select attributes that should not be placed in this zone.'"><span
                class="icon icon-Tooltip h5 d-inline align-text-bottom"></span></span>
            </cool-label>
            <b-form-checkbox-group class="small"
            v-model="banner.blocked_attrs">
              <b-row>
                <b-col lg="4" md="6" v-for="(item, index) in blockedAttributesOptions" :key="index" class="my-2">
                  <b-form-checkbox
                    :class="banner.blocked_attrs.indexOf(item.value) == -1 ? 'text-muted' : ''"
                    :value="item.value">
                    {{ item.text }}
                  </b-form-checkbox>
                </b-col>
              </b-row>
            </b-form-checkbox-group>
          </b-form-group>
        </div>
        <div>
          <b-form-group>
            <cool-label>
              Blocked Banner Types
              <span
                v-b-popover.hover.click.right="'Select banner formats that should not be placed in this zone.'"><span
                class="icon icon-Tooltip h5 d-inline align-text-bottom"></span></span>
            </cool-label>
            <b-form-checkbox-group
              v-model="banner.blocked_types"
              stacked
              class="small">
              <b-row>
                <b-col xl="4" md="6" class="my-2" v-for="(item, index) in bannerTypesOptions" :key="index">
                  <b-form-checkbox
                    :class="banner.blocked_types.indexOf(item.value) == -1 ? 'text-muted' : ''"
                    :value="item.value">
                    {{ item.text }}
                  </b-form-checkbox>
                </b-col>
              </b-row>
            </b-form-checkbox-group>
          </b-form-group>
        </div>
        <div v-if="medium.type === 'APP'">
          <b-form-group>
            <cool-label>
              APIs
              <span v-b-popover.hover.click.right="'Which APIs should this zone support? (optional)'"><span
                class="icon icon-Tooltip h5 d-inline align-text-bottom"></span></span>
            </cool-label>
            <b-form-checkbox-group
              v-model="banner.apis"
              class="small">
              <b-row>
                <b-col xl="4" md="6" class="my-2" v-for="(item, index) in apiOptions" :key="index">
                  <b-form-checkbox
                    :class="banner.apis.indexOf(item.value) === -1 ? 'text-muted' : ''"
                    :value="item.value">
                    {{ item.text }}
                  </b-form-checkbox>
                </b-col>
              </b-row>
            </b-form-checkbox-group>
          </b-form-group>
        </div>
      </b-col>
      <b-col>
        <b-form-group>
          <cool-label>
            Banner Dimensions
            <span
              v-b-popover.hover.click.right="'Select the different sizes of ads that should be allowed in this zone.'"><span
              class="icon icon-Tooltip h5 d-inline align-text-bottom"></span></span>
          </cool-label>
          <mulselect
            :options="bannerDimensionsOptions"
            :values="banner.dimensions"
            :limit="10">
          </mulselect>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>


<script type="text/javascript">
    import Mulselect from '@/components/Mulselect'

    export default {
        props: {
            value: {required: true, type: Object},
            medium: {required: true}
        },
        mounted() {
          let ba = this.value.blocked_attrs
          ba.push('AUDIO_AUTOPLAY')
          ba.push('IBV_AUTOPLAY')
          ba.push('PROVACATIVE')
          ba.push('ANIMATION_EXTREME')
          ba.push('ALERTSTYLE')
        },
        data() {
            return {
                bannerDimensionsOptions: [
                    {value: '300x250', label: '300 x 250'},
                    {value: '728x90', label: '728 x 90'},
                  {value: '150x150', label: '150 x 150'},
                  {value: '300x400', label: '300 x 400'},
                    {value: '320x50', label: '320 x 50'},
                    {value: '468x60', label: '468 x 60'},
                    {value: '320x480', label: '320 x 480'},
                    {value: '480x320', label: '480 x 320'},
                    {value: '300x100', label: '300 x 100'},
                  {value: '320x100', label: '320 x 100'},
                  {value: '300x120', label: '300 x 120'},
                    {value: '160x600', label: '160 x 600'},
                    {value: '300x600', label: '300 x 600'},
                  {value: '640x480', label: '640 x 480'},
                  {value: '728x250', label: '728 x 250'},
                    {value: '970x90', label: '970 x 90'},
                  {value: '970x250', label: '970 x 250'},
                  {value: '1280x100', label: '1280 x 100'}
                ],
                blockedAttributesOptions: [
                    {text: 'Audio Auto Play', value: 'AUDIO_AUTOPLAY'},
                    {text: 'Audio User Init', value: 'AUDIO_USERINIT'},
                    {text: 'Audio On/Off', value: 'AUDIO_ONOFF'},
                    {text: 'Expandable Auto', value: 'EXPANDABLE_AUTO'},
                    {text: 'Expandable Click', value: 'EXPANDABLE_CLICK'},
                    {text: 'Expandable Rollover', value: 'EXPANDABLE_ROLLOVER'},
                    {text: 'IBV Autoplay', value: 'IBV_AUTOPLAY'},
                    {text: 'IBV User Initiated', value: 'IBV_USERINIT'},
                    {text: 'Provocative', value: 'PROVACATIVE'},
                    {text: 'Extreme Animation', value: 'ANIMATION_EXTREME'},
                    {text: 'Interactive', value: 'INTERACTIVE'},
                    {text: 'Alert Style', value: 'ALERTSTYLE'},
                    {text: 'Skippable', value: 'SKIPPABLE'}
                ],
                bannerTypesOptions: [
                    {text: 'HTML Text', value: 'HTML_TEXT'},
                    {text: 'Javascript', value: 'JAVASCRIPT'},
                    {text: 'HTML Banner', value: 'HTML_BANNER'},
                    {text: 'iFrame', value: 'IFRAME'}
                ],
                apiOptions: [
                    {text: 'MRAID 1', value: 'MRAID1'},
                    {text: 'MRAID 2', value: 'MRAID2'}
                ]
            }
        },
        computed: {
            banner() {
                return this.value
            }
        },
        components: {
            Mulselect
        }
    }

</script>



// WEBPACK FOOTER //
// src/publisher/pages/Zone/ZoneSettings/AdFormats/BannerOptions.vue